module.exports = __webpack_public_path__ + "img/294-c4e271.png";